/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import { logout, getProfileInfo } from "../../network/ApiAxios";
import imgtoData from "../../variables/imgManipulation";
import NewPass from "components/Reusable Components/NewPass"

const CleanNavbar = (props) => {
  const [pic, setpic] = useState();
  const [user, setuser] = useState();

  useEffect(() => {
    let userStorage = JSON.parse(localStorage.getItem("user"));
    
  if(userStorage){
    setuser(userStorage);
    getProfilePic(userStorage);
  }
    
  }, []);
  let role = JSON.parse(localStorage.getItem("user")).role;
  
  let history = useHistory();

  const getProfilePic = async (user) => {
    
    if(user){
      const userID = user._id;
      const data = await getProfileInfo(userID);
      if (data.data.data) {
        const dat = data.data.data;
        setpic(imgtoData(dat));
      } else {
        setpic(require("assets/img/theme/team-1-800x800.jpg").default);
      }
    }
  };

  const logOut = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await logout(token);
      const { data } = response;
      if (data.success) {
        //localStorage.removeItem("token");
        //localStorage.removeItem("user");
        localStorage.clear();
        history.push("/auth/login");
      }
    }
  };

  return (
    <>
      
      <Navbar
        className="navbar navbar-dark"
        expand="md"
        id="navbar-main"
        style={{
          background: "linear-gradient(87deg, #11cdef 0, #1171ef 100%)",
        }}
      >
        <Container className="ml-9" fluid>
          <h1 className="text-light float-left"> {props.title} </h1>
          
          <Nav className="align-items-center float-right d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img alt=".a.." src={pic} />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {user ? user.name : ""}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to={"/" + role + "/profile"} tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to={"/" + role + "/newpass"} tag={Link}>
                  <i className="ni ni-key-25" />
                  <span>Change Password</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={logOut}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default CleanNavbar;
